var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,24c-2.206,0-4-1.794-4-4v-6h-2c-2.206,0-4-1.794-4-4s1.794-4,4-4h2v-2c0-2.206,1.794-4,4-4s4,1.794,4,4v2h2c2.206,0,4,1.794,4,4s-1.794,4-4,4h-2v6c0,2.206-1.794,4-4,4ZM6,8c-1.103,0-2,.897-2,2s.897,2,2,2h3c.552,0,1,.447,1,1v7c0,1.103,.897,2,2,2s2-.897,2-2v-7c0-.553,.448-1,1-1h3c1.103,0,2-.897,2-2s-.897-2-2-2h-3c-.552,0-1-.447-1-1v-3c0-1.103-.897-2-2-2s-2,.897-2,2v3c0,.553-.448,1-1,1h-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8476530469304fbdba1c89ee1d217ee0.svg";
export { ForwardRef as ReactComponent };